<!--
 * @Author: 仙道
 * @Date: 2022-07-03 17:29:27
 * @LastEditTime: 2022-09-25 19:20:30
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/eMaintenance/modules/TaskPlanTable.vue
-->
<template>
  <a-card :bordered="false" class="taskPlanTable">
    <!-- table区域-begin -->
    <div style="color: rgba(0, 0, 0, 0.85);font-weight: bold;margin-bottom: 20px;" v-if="canEdit">执行情况</div>
    <a-table
      :columns="filterCloum"
      :dataSource="tableList"
      :pagination="false"
      :scroll="{x:false, y: 500 }"
      bordered
      ref="table"
      rowKey="uuid"
      size="small"
    >
      <!-- <template slot="bj" slot-scope="text, record">
        <a @click="addBj(record)">添加</a>
      </template>-->
      <template slot="execute" slot-scope="option,record,index,event">
        <a-switch
          :checked="Boolean(record.isExecute)"
          @change="onCellChange(record.uuid, 'isExecute', $event)"
          v-if="type=='form'"
        ></a-switch>
        <span v-else>{{record.isExecute?'已执行':'未执行'}}</span>
      </template>
    </a-table>
    <!-- table区域-end -->

    <!-- 备品备弹窗件列表 -->
    <DevBpbjInfoList :repairPlanId="repairPlanId" :title="deviceName" @refresList="refresList" ref="DevBpbjInfoList"></DevBpbjInfoList>
  </a-card>
</template>

<script>
  import EditableCell from './EditCell.vue'
  import DevBpbjInfoList from './DevBpbjInfoList'
  export default {
    name: "RowspanTable",
    props: {
      dataSource: {
        type: Array,
        default: () => []
      },
      type: {
        type: String,
        default: 'form'
      },
      repairPlanId: {
        type: String,
        default: ''
      },
      canEdit: {
        type: Boolean,
        default: false
      }
    },
    components: {
      EditableCell,
      DevBpbjInfoList,
    },
    // watch:{
    //   canEdit(newv){
    //     console.log('newv---',newv)
    //     if(newv){
    //       columns = columns.splice(1, 0, {
    //         //备件消耗
    //         title: '备件消耗',
    //         align: "center",
    //         dataIndex: 'bj',
    //         scopedSlots: { customRender: 'bj' },

    //       })
    //     }
    //   }
    // },
    computed: {
      filterCloum () {
        if (this.canEdit) {
          this.columns.splice(1, 0, {
            //备件消耗
            title: '备件消耗',
            align: "center",
            dataIndex: 'bj',

            customRender: (value, row,) => {
              return {
                children: (<a-button type="primary" size="small" onclick={() => this.addBj(row)}>添加</a-button>),
                attrs: {
                  rowSpan: parseInt(row.rowSpan)
                },
              };

            },
            // scopedSlots: { customRender: 'bj' },

          })
        }
        return this.columns
      }
    },
    data () {
      return {
        description: '保养任务设备关联页面',

        // 表头
        columns: [
          {
            title: '保养对象',
            align: "center",
            dataIndex: 'devName',

            customRender: (value, row, index) => {
              const obj = {
                children: value,
                attrs: {},
              };
              obj.attrs.rowSpan = parseInt(row.rowSpan)
              return obj
            }

          },
          // {
          //   //备件消耗
          //   title: '备件消耗',
          //   align: "center",
          //   dataIndex: 'bj',
          //   scopedSlots: { customRender: 'bj' },

          // },
          {
            title: '保养部位',
            align: "center",
            dataIndex: 'maintenancePlace'
          },

          {
            title: '保养操作',
            align: "center",

            dataIndex: 'maintenanceOperate'
          }, {
            title: '是否执行',
            align: 'center',
            key: 'isExecute',

            // dataIndex: 'isExecute',
            scopedSlots: { customRender: 'execute' }
          }],
        tableList: [],
        deviceName: ''
      }
    },
    created () {

      this.tableList = this.dataSource
      // if (this.type == 'form') {
      //   this.columns = this.columns.concat({
      //     title: '是否执行',
      //     align: 'center',
      //     key: 'isExecute',
      //     // dataIndex: 'isExecute',
      //     scopedSlots: { customRender: 'execute' }
      //   })
      // }
    },
    methods: {
      tableListChange (list) {
        this.tableList = list
        this.$refs.DevBpbjInfoList.dataSource = []
      },
      getDataList () {
        return this.$Jlodash.clone(this.tableList)
      },
      onCellChange (key, dataIndex, value) {

        const dataSource = [...this.tableList];

        const target = dataSource.find(item => item.uuid === key);
        if (target) {
          target[dataIndex] = value ? 1 : 0;
          this.tableList = dataSource;
        }
      },
      addBj (item) {
        console.log('item===', item)
        this.deviceName = `${item?.devName}：消耗备件`
        this.$refs.DevBpbjInfoList.open(item)
      },
      // 消耗备品备件列表
      refresList (data) {
        this.$emit('refresList', data)
      }

    }
  }
</script>
<style lang="less">
  .taskPlanTable {
    .ant-card-body .table-operator {
      margin-bottom: 18px;
    }
    .ant-table-tbody .ant-table-row td {
      padding-top: 15px;
      padding-bottom: 15px;
    }
    .anty-row-operator button {
      margin: 0 5px;
    }
    .ant-btn-danger {
      background-color: #ffffff;
    }

    .ant-modal-cust-warp {
      height: 100%;
    }
    .ant-modal-cust-warp .ant-modal-body {
      height: calc(100% - 110px) !important;
      overflow-y: auto;
    }
    .ant-modal-cust-warp .ant-modal-content {
      height: 90% !important;
      overflow-y: hidden;
    }
    .ant-card-body {
      padding-top: 12px;
      padding-bottom: 12px;
    }
  }
</style>

